import { render, staticRenderFns } from "./swedish-validation-modal.vue?vue&type=template&id=7849af8d&scoped=true&"
import script from "./swedish-validation-modal.vue?vue&type=script&lang=js&"
export * from "./swedish-validation-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7849af8d",
  null
  
)

export default component.exports